import classNames from 'classnames/bind';
import styles from './CreateTipType.module.scss';
import TipForm from '../Form/TipForm';
import { useContext, useEffect, useRef, useState } from 'react';
import { ToastContext } from '../Context/ToastProvider';
import { getData, postData } from '~/helper/apiService';
import { ModalOverLayContext } from '../Context/ModalOverLayProvider';
import TipTypeForm from '../Form/TipTypeForm';

const cx = classNames.bind(styles);

function CreateTipType() {
  const fileInputRef = useRef(null);
  const [key, setKey] = useState('');
  const { addToast } = useContext(ToastContext);
  const { setModalComponentContent } = useContext(ModalOverLayContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    // Gửi dữ liệu lên máy chủ hoặc xử lý tại client-side
    const res = await postData('/tips/createtype', formData);
    if (res.status === 'success') {
      setKey((prev) => prev + 1);
      setModalComponentContent(null);
    }
    addToast(res);
  };
  return (
    <div className={cx('wrapper')}>
      <TipTypeForm key={key} titleBtn="Create tip type" handleSubmit={handleSubmit} fileInputRef={fileInputRef} />
    </div>
  );
}

export default CreateTipType;
